import { ILogin, IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IModal } from "./FollowUpPoc";
import { format } from "date-fns";
import { PendingFollowup } from "./PendingFollowup";
import { Dialog } from "primereact/dialog";
import { Dailer } from "./Dailer";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Toolbar } from "primereact/toolbar";
import { SendEmailForPaymentUpdate } from "./SendEmailForPaymentUpdate";
import ReadMoreTableComponent from "./readMoreTableComponent";
import parse from 'html-react-parser';
import { IEmailTempDropdown } from "../../models/IDropdown";
import { ISignatureMast } from "../../models/SignatureMast";
import { IEmailTemplate } from "../../models/EmailTemplate";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Dropdown } from "primereact/dropdown";
import { JVInput } from "../../shared/JVInput";
import { safeFormatDate } from "../../models/DateFormatMapper";


export interface IVFollowupoc {
    extension_ID?: number,
    callerID?: string,
    ext_Destination?: number,
    displayName?: string,
};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
    hideDialog: () => void,
}

export const EmptyExtCalling = {
    displayName: "",
}
const schema = yup.object({
});

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ data: [], totalAssignfollowup: 0, remainingCount: 0, followupdoneCount: 0, loading: false } as { data: IVFollowupoc[], totalAssignfollowup: number, remainingCount: number, followupdoneCount: number, loading: boolean });
    const [openPendingFollowUp, setOpenPendingFollowUp] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean })
    const [mailHistory, setMailHistory] = useState({ followup_ID: 0, open: false } as { followup_ID: number, open: boolean })
    const [historyData, setHistoryData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const dt = useRef<any>(null);
    const [openCallDailor, setOpenCallDailor] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean })
    const [loading, setLoading] = useState(false);
    const [openMailBody, setOpenMailBody] = useState({ singleData: {}, contact_Person_EmailID: "", open: false } as { singleData: any, contact_Person_EmailID: string, open: boolean })
    const [mailBody, setMailBody] = useState("");
    const [selectedPoc, setSelectedPoc] = useState<any[]>();
    const [openSendEmail, setOpenSendEmail] = useState(false);
    const [viewDialogVisible, setViewDialogVisible] = useState(false);
    const [selectedComment, setSelectedComment] = useState<string>("");
    const [emailTemplatesData, setEmailTemplatesData] = useState<Array<IEmailTempDropdown>>();
    const [etId, setEtId] = useState(0);
    const [body, setBody] = useState("");
    const [signature, setSignature] = useState({ val: "", disabled: true });
    const [signatureDetails, setSignatureDetails] = useState<ISignatureMast>({});

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<any>({
        resolver: yupResolver(schema),

        shouldFocusError: false
    });


    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Followup POC List</h5>
        </div>
    );

    const openEdit = (rowData: IVFollowupoc) => {
        props.setModal({ open: true, singleData: rowData });
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("InActivePrimeVendor/getFollowupPoc", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ data: data.followuplist, remainingCount: data.remainingCount, totalAssignfollowup: data.totalAssignfollowup, followupdoneCount: data.followupdoneCount, loading: false });
        }
    }

    const CreatedOn = (rowData: any) => {
        let date;
        if (rowData.next_Followup_Date) date = format(new Date(rowData.next_Followup_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const HidePendingFollowup = () => {
        props.hideDialog();
        setOpenPendingFollowUp({ singleData: {}, open: false });
        setOpenCallDailor({ singleData: {}, open: false })
    }

    const getMailFollowupHistory = async (data: any) => {
        setHistoryData({ tableData: historyData.tableData, loading: true });

        const response = await Fetch("InActivePrimeVendor/getFollowupHistory", "GET", null, `followup_ID=${data.followup_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setHistoryData({ tableData: data, loading: false });
        } else setHistoryData({ tableData: historyData.tableData, loading: false });

    }


    const sendMail = (rowData: any) => {
        const mailTemplate = `
            Dear ${rowData.contact_Person_Name},<br/><br/>
            You are inactive in POC. Please follow up at your earliest convenience.<br/><br/>
            Regards,<br/>
            
        `;
        setMailBody(mailTemplate);
        setOpenMailBody({ singleData: rowData, contact_Person_EmailID: rowData.contact_Person_EmailID, open: true });
    };

    const action1 = (rowData: any) => {
        return (
            <div className="actions">
                <Button icon="pi pi-history" className="p-button-rounded p-button-text" onClick={() => { setMailHistory({ followup_ID: rowData.followup_ID, open: true }); getMailFollowupHistory(rowData); }} tooltip="View history" />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
                <Button icon="pi pi-phone" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => { setOpenCallDailor({ open: true, singleData: rowData }); callOnNumber(rowData) }} />
                <Button icon="pi pi-envelope" className="p-button-rounded p-button-text ml-2" onClick={() => { sendMail(rowData) }} tooltip="Send Mail" />
            </div>
        );
    };

    const loadSignature = async () => {
        const response = await Fetch("Signature_Mast", "GET", null, null, null);
        if (response) {
            const data: ISignatureMast = await response.json();
            setSignatureDetails(data);
            if (data.signature) setSignature({ val: data.signature, disabled: signature.disabled });
        }
    }

    const loadEmailTemplates = async () => {
        const response = await Fetch("DropDown/emailTemplateofFollowup", "GET", null, null, null);
        if (response) {
            const data: Array<IEmailTempDropdown> = await response.json();
            setEmailTemplatesData(data);
        }
    }

    const fillEmailTemplate = async () => {
        const response = await Fetch("Email_Template/byId", "GET", null, `id=${etId}`, null);
        if (response) {
            const data: IEmailTemplate = await response.json();
            if (data.template_Subject) setValue("subject", data.template_Subject);
            if (data.template_Body) setBody(data.template_Body);
        }
    }

    useEffect(() => {
        if (etId) fillEmailTemplate();
    }, [etId]);

    const onHide = () => {
        setMailHistory({ followup_ID: 0, open: false })
        setOpenMailBody({ singleData: "", contact_Person_EmailID: "", open: false });
        setOpenSendEmail(false);
        setSelectedPoc([]);
        reset({ subject: "" }); setBody(""); setEtId(0);

    }

    useEffect(() => {
        if (openMailBody.open) {
            loadSignature();

            loadEmailTemplates();
        }
    }, [openMailBody.open]);

    const pDate1 = (rowData: any) => {
        let date;
        if (rowData.createdon) date = format(new Date(rowData.createdon), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const nextFollowupDate = (rowData: any) => {
        let date;
        if (rowData.next_Followup_Date) date = format(new Date(rowData.next_Followup_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const assignedOn = (rowData: any) => {
        let date;
        if (rowData.createdon) date = format(new Date(rowData.createdon), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const rightToolbarTemplate = () => {
        return (
            <Button
                label="Send Follow up Email"
                onClick={() => {
                    if (selectedPoc && selectedPoc.length > 0) {
                        setOpenSendEmail(true); // Open bulk update modal
                    } else {
                        props.toast.current.show({ severity: 'warn', detail: 'Please select at least 1 invoices to send email.', life: 3000, });
                    }
                }}
            />
        );
    };


    const callOnInputNumber = async (rowData?: any) => {
        console.log(rowData)
        const phone = rowData?.phone_No || "";
        const cell = rowData?.cell_No || "";
        let dialNumber = "";
        const cleanNumber = (num: string) => num.replace(/[^0-9]/g, "").trim();
        if (loginObj.ext_Destination === null) {
            props.toast.current.show({ severity: 'error', detail: "Your extension number is not updated", life: 3000 });
            return;
        }
        // Try phone_No first
        // if (phone && cleanNumber(phone).length >= 10 && cleanNumber(phone) !== "0000000000") {
        //     dialNumber = cleanNumber(phone);
        // }
        // // Fallback to cell_No
        // else if (cell && cleanNumber(cell).length >= 10 && cleanNumber(cell) !== "0000000000") {
        //     dialNumber = cleanNumber(cell);
        // }
        // console.log(dialNumber)
        // // If neither is valid
        // if (!dialNumber) {
        //     props.toast.current.show({ severity: 'error', detail: "Valid POC number not found", life: 3000 });
        //     return;
        // }
        dialNumber = "121"
        //const response = await fetch(`https://billing.vitelglobal.com/clicktocall/index.php?fromnum=${loginObj.ext_Destination}&tonum=${dialNumber}&vitelusername=${loginObj.ivR_Company}`);
        //const result = await response.json();
        //if (response) {
        //  console.log(await response.json());
        //}
    };

    const callOnNumber = async (body?: any) => {
        setLoading(true);

        const response = await Fetch("InActivePrimeVendor/getsCalling", "POST", body, `ext_Destination=${loginObj.ext_Destination}&ivR_Company=${loginObj.ivR_Company}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Calling Successfully", life: 3000 });
            //  props.loadTableData();
            // props.setReload(!props.reload);

            // props.HidePenFollowup();
        }
        setLoading(false);
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    const onSubmitMailForm = async (data: any) => {
        if (body.length < 1) {
            props.toast.current.show({ severity: 'error', detail: "Choose Template First.", life: 3000 });
        } else {
            setLoading(true);
            const emailPayload = {
                followup_ID: openMailBody.singleData.followup_ID,
                contact_Person_ID: openMailBody.singleData.contact_Person_ID,
                contact_Person_EmailID: openMailBody.contact_Person_EmailID,
                subject: data.subject,
                signature: signature.val,
                emailBody: body
            };
            const response = await Fetch("InActivePrimeVendor/sendFollowupMail", "POST", emailPayload, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: "success", detail: "Email Sent Successfully!", life: 3000 });
            }
            setLoading(false);
            onHide();
        }
    };

    const renderContent = (rowData: any) => {
        const rawContent = rowData.comment || '';
        const cleanedContent = rawContent.replace(/^\s+/gm, '').trim();
        if (cleanedContent.length > 50) {
            const less = cleanedContent.substring(0, 50) + '...';
            return <ReadMoreTableComponent less={less} more={cleanedContent} />;
        } else {
            return <div>{parse(cleanedContent.replace(/\n/g, '<br />'))}</div>;
        }
    };


    // const mailContent = (rowData: any) => {
    //     return (
    //         <div dangerouslySetInnerHTML={{ __html: rowData.comment.content }} />
    //     )
    // }
    const handleViewComment = (rowData: any) => {
        setSelectedComment(rowData.comment);
        setViewDialogVisible(true);
    };

    const DateFormat = loginObj?.date_Format;


    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <h1 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#333', margin: '0 0 0.5rem 0', }}>
                Assigned POC: {tableData.totalAssignfollowup} / {tableData.followupdoneCount} (Follow-ups Completed)
            </h1>
            <h1 style={{ fontSize: '1.1rem', fontWeight: '500', color: '#333', margin: '0 0 1rem 0', }}>
                Remaining Follow-ups:&nbsp;
                <button style={{
                    fontSize: '1rem', fontWeight: '600', backgroundColor: '#e53935', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer', transition: 'background-color 0.3s',
                }}
                >{tableData.remainingCount}
                </button>
            </h1>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data}
                resizableColumns columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
                selection={selectedPoc}
                onSelectionChange={(e) => {
                    setSelectedPoc(e.value);

                }}
                selectionMode="checkbox"
                dataKey="followup_ID"
            >
                <Column selectionMode="multiple" />
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="salesManager_Name" header="Sales Manager" />
                <Column field="vendor_Company_Name" header="Vendor Company" />
                <Column field="contact_Person_Name" header="Contact Person" />
                {/* <Column field="" header="Assigned On" body={assignedOn} /> */}
                <Column field="createdon" header="Assigned On" body={(rowData: any) => safeFormatDate(rowData.createdon, "dd/MM/yyyy", DateFormat)} />
                <Column field="isFollowupMail" header="Follow-Up Mail" body={(rowData) => <p style={{ color: rowData.isFollowupMail ? 'blue' : 'red', margin: 0 }}>{rowData.isFollowupMail === true ? "Yes" : "No"}</p>} />
                <Column field="isFollowupMail" header="Follow-Up Call" body={(rowData) => <p style={{ color: rowData.isFollowupOnPhone ? 'blue' : 'red', margin: 0 }}>
                    {rowData.isFollowupOnPhone ? "Yes" : "No"}
                </p>} />
                {/* <Column field="" header="Follow-up Date" body={CreatedOn} /> */}
                <Column field="" header="Follow-up Date" body={(rowData: any) => safeFormatDate(rowData.next_Followup_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="" header="Action" body={action1} />

            </DataTable>
            <Dailer singleData={openCallDailor.singleData} open={openCallDailor.open} loadTableData={loadTableData} toast={props.toast} HidePenFollowup={HidePendingFollowup} />

            <PendingFollowup singleData={openPendingFollowUp.singleData} open={openPendingFollowUp.open} loadTableData={loadTableData} toast={props.toast} HidePenFollowup={HidePendingFollowup} />
            <Dialog visible={mailHistory.open} style={{ width: '40vw' }} header="History of Follow-Up" modal className="p-fluid" onHide={onHide} >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows scrollable scrollHeight="65vh"
                    emptyMessage="No requirement found."
                    value={historyData.tableData}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    {/* <Column field="" header="Follow-up Type" body={(rowData) => <p>{rowData.history_Type === 1 ? "Mail" : rowData.history_Type === 3 ? "Call" : ""} </p>} /> */}

                    {/* <Column field="next_Followup_Date" header="Follow-up Date" body={nextFollowupDate} /> */}
                    <Column field="next_Followup_Date" header="Follow-up Date" body={(rowData: any) => safeFormatDate(rowData.next_Followup_Date, 'dd/MM/yyyy', DateFormat)} />
                    <Column style={{ maxWidth: '20rem' }}
                        field="createdon"
                        header="Activities"
                        body={(rowData) => (
                            <div className="flex align-items-center gap-2">
                                <i
                                    className={`pi ${rowData.history_Type === 1 ? 'pi-envelope' : rowData.history_Type === 3 ? 'pi-phone' : ''}`}
                                    style={{ color: '#6366F1' }}
                                />
                                <span>
                                    {rowData.history_Type === 1 ? 'Mail' : rowData.history_Type === 3 ? 'Call' : 'Other'} - {safeFormatDate(rowData.createdon, 'dd/MM/yyyy', DateFormat)}
                                </span>
                            </div>
                        )}
                    />
                    <Column header="View" body={(rowData) => (<Button icon="pi pi-eye" className="p-button-rounded p-button-text" tooltip="View Comment/Mail Content" onClick={() => handleViewComment(rowData)} />)} />
                </DataTable>
            </Dialog>
            <Dialog header="View Comment / Mail Content" visible={viewDialogVisible} style={{ width: '30vw' }} onHide={() => setViewDialogVisible(false)} >
                <div
                    dangerouslySetInnerHTML={{ __html: selectedComment || "<i>No content</i>" }}
                    style={{ whiteSpace: 'pre-line', lineHeight: '1.5', fontSize: '15px' }}
                />
            </Dialog>
            <Dialog header="" visible={openMailBody.open} style={{ width: '50vw', height: "200" }} onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmitMailForm)} className="p-fluid formgrid grid flex">
                    <div className="field col-12 md:col-6">
                        <Dropdown options={emailTemplatesData} optionValue={"template_Id"} optionLabel={"template_Name"} value={etId} onChange={e => setEtId(e.value)} placeholder="Choose Email Template" />
                    </div>
                    <JVInput column={1} label="Subject" control={control} name="subject" />
                    <div className="col-12 md:col-12 md:col-6 mb-3">
                        <div>
                            <p>Note:</p> Do not remove or edit @POC_Name. It will be automatically replaced with the contact person's name when sending the email.
                        </div>
                        <label>Body</label>
                        <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => { setBody(editor.getData()); }} />
                    </div>
                    <div className="col-12 md:col-12 md:col-6">
                        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                            <label>Signature</label>
                            <div className="field-checkbox m-1">
                                {/* {signature.disabled ? <Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => setSignature({ val: signature.val, disabled: false })} /> */}
                                {/* : <Button type="button" icon="pi pi-ban" className="p-button-rounded p-button-text" onClick={() => setSignature({ val: signature.val, disabled: true })} />} */}
                                {/* <label className="mr-1" htmlFor="binary">Short Sign</label> */}
                                {/* <Checkbox inputId="binary" checked={isShort} onChange={e => setIsShort(e.checked)} /> */}
                            </div>
                        </div>
                        <CKEditor editor={ClassicEditor} data={signature.val} onChange={(event, editor) => { setSignature({ val: editor.getData(), disabled: signature.disabled }); }} disabled={signature.disabled} />
                    </div>

                    <div className="col-12 md:col-12 flex justify-content-between">
                        <Button className="field col-12 md:col-4 h-2rem" style={{ width: "49%" }} label="SEND" type="submit" loading={loading}></Button>
                        <Button className="field col-12 md:col-4 p-button-outlined h-2rem" style={{ width: "49%" }} label="CANCEL" onClick={onHide} type="button"></Button>
                    </div>
                </form>
            </Dialog>
            <SendEmailForPaymentUpdate tableData={selectedPoc || []} openSendEmail={openSendEmail} closeSendEmailModal={onHide} toast={props.toast} />

        </>
    );
}  